<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <fccTable
      striped
      hover
      :fields="configTableGerencFilas.fields"
      :status="configTableGerencFilas.status"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePage"
      :actions="configTableGerencFilas.actions"
      addFilter
      :items="listaParametros"
    />

    <fcc-modal
      centered
      id-modal="modal-parametros"
      :title-modal="titleModalSituacao"
      esconde-footer
      trava-esc
      trava-back
    >
      <b-form @submit.prevent="submitModalParam" autocomplete="off">
        <div class="row">
          <div class="col-md-12">
            <fcc-select
              class="mb-4"
              placeholder="Selecione uma fila"
              labelField="fildescricao"
              valueField="filid"
              v-model="itemParam.filid"
              :options="listaFilas"
              required
            >
              Fila
            </fcc-select>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-6">
            <fcc-input
              extra-classes="inputLabel"
              v-model="itemParam.filparlimitepublicador"
              required
            >
              Limite de envio
            </fcc-input>
          </div>
          <div class="col-md-6">
            <fcc-input
              extra-classes="inputLabel"
              v-model="itemParam.filparlimiteconsumidor"
              required
            >
              Limite de consumidor
            </fcc-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <fcc-input extra-classes="inputLabel mb-4" v-model="itemParam.filparnomequeue" required>
              Queue
            </fcc-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fcc-input extra-classes="inputLabel mb-4" v-model="itemParam.filpartimeout" required>
              Timeout (segundos)
            </fcc-input>
          </div>
          <div class="col-sm-6 text-left">
            <span
              ><toggle-button v-model="itemParam.filparconsumidorenviaemail" :sync="true" /> Envia
              e-mail</span
            >
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </b-form>
    </fcc-modal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      titlePage: 'Parâmetros',
      itemPorPage: '100',
      listaParametros: [],
      listaFilas: [],
      itemParam: {
        filparid: 0,
        filid: 0,
        filparlimitepublicador: null,
        filparlimiteconsumidor: null,
        filparnomequeue: '',
        filparconsumidorenviaemail: true,
        filpartimeout: null
      },

      configTableGerencFilas: {
        fields: [
          { key: 'filparid', label: 'ID', sortable: true, active: true },
          {
            key: 'fila',
            label: 'Fila',
            sortable: true,
            active: true,
            type: 'sub',
            sub: { sub1: 'fila', sub2: 'fildescricao' }
          },
          { key: 'filparnomequeue', label: 'Queue', sortable: true, active: true },
          { key: 'filparlimitepublicador', label: 'Limite envio', sortable: true, active: true },
          { key: 'filparlimiteconsumidor', label: 'Limite consumo', sortable: true, active: true },
          { key: 'filpartimeout', label: 'Timeout', sortable: true, active: true },
          {
            key: 'filparconsumidorenviaemail',
            label: 'Envia e-mail',
            active: true,
            funcaoButton: this.changeEnviaEmail,
            tdClass: 'no-print',
            thClass: 'no-print',
            type: 'toggle',
            objpermCodigo: store.state.permissaoMenu.editar
          },
          { key: 'actions', label: '', thClass: 'no-print', tdClass: 'text-nowrap no-print' }
        ],
        actions: [
          {
            button: true,
            funcaoButton: this.editarFilas,
            icon: 'edit',
            tooltip: 'Editar',
            objpermCodigo: store.state.permissaoMenu.editar
          },
          {
            button: true,
            funcaoButton: this.deletarFilas,
            icon: 'trash-alt',
            tooltip: 'Excluir',
            objpermCodigo: store.state.permissaoMenu.excluir
          }
        ],
        status: [
          {
            funcaoButton: this.editarFilas,
            tooltip: 'Alterar Parâmetros',
            campoStatus: 'ativo',
            objpermCodigo: store.state.permissaoMenu.editar
          }
        ]
      }
    }
  },

  methods: {
    getDadosGerencFilasParametros: function () {
      this.carregaTexto(this.codeMensagem('C01'))

      Promise.all([
        axios.get(
          store.state.baseUrlTransferenciaArquivos + 'FilaParam/ListarFilaParam',
          this.dadosLoginSession.fccTokenHeaders
        ),
        axios.get(
          store.state.baseUrlTransferenciaArquivos + 'Fila/ListarFila',
          this.dadosLoginSession.fccTokenHeaders
        )
      ])
        .then((response) => {
          this.listaParametros = response[0].data
          this.listaFilas = response[1].data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },

    addField() {
      this.itemParam = {
        filparid: 0,
        filid: 0,
        filparlimitepublicador: null,
        filparlimiteconsumidor: null,
        filparnomequeue: '',
        filparconsumidorenviaemail: true,
        filpartimeout: null
      }
      this.$bvModal.show('modal-parametros')
    },

    editarFilas(_, item) {
      this.itemParam = { ...item }
      this.$bvModal.show('modal-parametros')
    },

    deletarFilas(_, item) {
      this.callConfirm(this.mensagemExcluir, item.filparnomequeue).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C02'))

          axios
            .delete(
              store.state.baseUrlTransferenciaArquivos +
                'FilaParam/ExcluirFilaParam/' +
                item.filparid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callToast(this.mensagensUpdate.excluido)
              this.getDadosGerencFilasParametros()
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },

    changeEnviaEmail(_, item) {
      this.itemParam = item
      this.submitModalParam()
    },

    submitModalParam() {
      this.carregaTexto(this.codeMensagem('C03'))

      const novoRegistro = this.itemParam.filparid == null || this.itemParam.filparid == 0
      let request

      if (novoRegistro) {
        request = axios.post(
          store.state.baseUrlTransferenciaArquivos + 'FilaParam/AdicionarFilaParam',
          this.itemParam,
          this.dadosLoginSession.fccTokenHeaders
        )
      } else {
        request = axios.put(
          store.state.baseUrlTransferenciaArquivos + 'FilaParam/AlterarFilaParam',
          this.itemParam,
          this.dadosLoginSession.fccTokenHeaders
        )
      }

      request
        .then(() => {
          this.getDadosGerencFilasParametros()
          this.$bvModal.hide('modal-parametros')
          this.callToast(
            novoRegistro ? this.mensagensUpdate.adicionado : this.mensagensUpdate.editado,
            'success'
          )
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },

  computed: {
    titleModalSituacao() {
      return this.itemParam.filid != null && this.itemParam.filid != 0
        ? 'Editar Parâmetros'
        : 'Adicionar Parâmetros'
    }
  },

  created() {
    this.getDadosGerencFilasParametros()
  }
}
</script>
